import { Module } from "vuex";

import { AppointmentsApi } from "@/api/appointment";
import { CancelAppointment } from "@/store/modules/appointments/interfaces/CancelAppointment";
import { PostAppointmentBody } from "@/store/modules/appointments/interfaces/PostAppointmentBody";
import { RootState } from "@/types";

export const appointments: Module<Record<string, unknown>, RootState> = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async scheduleAppointment(ctx, payload: PostAppointmentBody) {
      return AppointmentsApi.create(payload);
    },
    async cancelAppointment(ctx, payload: CancelAppointment) {
      return AppointmentsApi.cancel(payload);
    },
  },
  getters: {},
};
